import { Provider } from '@angular/core';

import { ClockingRepositoryImpl } from '@app/data/repositories/mot/clocking/clocking.repository';
import { CLOCKING_REPOSITORY as CLOCKING_REPOSITORY } from '@app/domain/repositories/mot/clocking.repository.contract';

export const clockingRepositoryProvider: Provider = {
  provide: CLOCKING_REPOSITORY,
  useClass: ClockingRepositoryImpl
};
